





























import {
  defineComponent,
  PropType,
  toRef,
  ref,
  onMounted,
  onUpdated,
  computed,
} from "@nuxtjs/composition-api";
import type { Product } from "@wemade-vsf/catalog/lib/runtime/product/types";
import { useProductGallery } from "@wemade-vsf/catalog/lib/runtime/product/composables/useProductGallery";
import ProductLabels from "components/catalog/Product/ProductLabels.vue";

export default defineComponent({
  name: "ProductGallery",
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    product: {
      type: [Object, null] as PropType<Product>,
      default: null,
    },
    filter: {
      type: String,
      default: "",
    },
    current: {
      type: Number,
      default: 1,
    },
    enableZoom: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ProductLabels,
  },
  setup(props, { emit }) {
    const product = toRef(props, "product");
    const { productGallery, imageSizes } = useProductGallery(product);

    const videoItems = computed(() =>
      productGallery.value
        ? productGallery.value.filter((p) => p.video && p.video.video_url)
        : []
    );
    const imageItems = computed(() =>
      productGallery.value
        ? productGallery.value.filter((p) => !p.video || !p.video.video_url)
        : []
    );

    const galleryImgEl = ref(null);
    const isZoomStarted = ref(false);
    const eventHover = ref({});
    const positionStatic = ref({ x: 0, y: 0 });

    function positionObject(index) {
      if (galleryImgEl.value && galleryImgEl.value[index]) {
        return galleryImgEl.value[index].getBoundingClientRect();
      }
      return "";
    }

    function startZoom() {
      if (props.enableZoom) {
        isZoomStarted.value = true;
      }
    }

    function moveZoom($event, index) {
      if (props.enableZoom) {
        eventHover.value = $event;
        positionStatic.value = positionObject(index);
        if (
          positionStatic.value &&
          galleryImgEl.value &&
          galleryImgEl.value[index]
        ) {
          galleryImgEl.value[index].children[0].style.cssText =
            "top: 0; transform: scale(2);";
          galleryImgEl.value[index].children[0].style.transformOrigin = `${
            $event.clientX - positionStatic.value.x
          }px ${$event.clientY - positionStatic.value.y}px`;
        }
      }
    }

    function removeZoom(index) {
      if (props.enableZoom) {
        isZoomStarted.value = false;
        if (galleryImgEl.value?.[index]) {
          galleryImgEl.value[index].children[0].style.transform = "scale(1)";
        }
      }
    }

    onMounted(() => {
      emit("init", {
        numImages: imageItems.value.length,
        numVideos: videoItems.value.length,
      });
    });

    onUpdated(() => {
      emit("init", {
        numImages: imageItems.value.length,
        numVideos: videoItems.value.length,
      });
    });

    return {
      imageSizes,
      galleryImgEl,
      moveZoom,
      productGallery,
      removeZoom,
      startZoom,
    };
  },
});
